<template>
  <div>
    <v-snackbar v-model="showCopy" :timeout="6000" color="green" :top="true"
      >{{ $t('Link Copied') }}!</v-snackbar
    >
    <v-container>
      <v-layout class="mb-5">
        <v-flex>
          <div style="margin-top: 10px">{{ $t('Activate bot') }}</div>
          <div class="red--text">
            ***
            {{ $t('Information will not be recorded in analytics if the bot is inactivated2') }}
          </div>
        </v-flex>
        <v-flex shrink>
          <label
            class="toggle-switch small"
            style="margin-top: 10px; margin-bottom: 10px; vertical-align: bottom"
          >
            <input type="checkbox" :checked="botStatus" @change="toggleBotStatus()" />
            <span class="toggle-slider lever round"></span>
          </label>
        </v-flex>
      </v-layout>
      <div
        v-if="selectedBot.status"
        class="hr"
        style="margin-top: 20px; border-color: rgba(0, 0, 0, 0.12)"
      ></div>
      <div
        v-if="selectedBot.status"
        class="text-xs-center"
        style="margin: -13px; margin-bottom: 10px"
      >
        <a
          class="text btn-advanced"
          href="javascript:void(0);"
          style="position: relative"
          @click="onOffbotToggle = !onOffbotToggle"
        >
          <em
            class="fa"
            :class="{ 'fa-angle-down': !onOffbotToggle, 'fa-angle-up': onOffbotToggle }"
          />
        </a>
      </div>

      <template v-if="onOffbotToggle">
        <v-layout wrap row>
          <v-flex xs8>
            <div class="pl-2 pt-3">{{ $t('activate_facebook') }}</div>
          </v-flex>
          <v-flex xs4 class="text-xs-right">
            <div class="pt-2">
              <toggle-button
                class="mt-2"
                :value="toggleFacebook"
                :sync="true"
                :color="$vuetify.theme.success"
                :labels="{ checked: 'ON', unchecked: 'OFF' }"
                style="display: inline-block"
                @change="onChangeToggleClosePlatFrom('facebook')"
              />
            </div>
          </v-flex>
        </v-layout>
        <v-layout wrap row>
          <v-flex xs8>
            <div class="pl-2 pt-3">{{ $t('activate_line') }}</div>
          </v-flex>
          <v-flex xs4 class="text-xs-right">
            <div class="pt-2">
              <toggle-button
                class="mt-2"
                :value="toggleLine"
                :sync="true"
                :color="$vuetify.theme.success"
                :labels="{ checked: 'ON', unchecked: 'OFF' }"
                style="display: inline-block"
                @change="onChangeToggleClosePlatFrom('line')"
              />
            </div>
          </v-flex>
        </v-layout>
        <v-layout wrap row>
          <v-flex xs8>
            <div class="pl-2 pt-3">{{ $t('activate_instagram') }}</div>
          </v-flex>
          <v-flex xs4 class="text-xs-right">
            <div class="pt-2">
              <toggle-button
                class="mt-2"
                :value="toggleIg"
                :sync="true"
                :color="$vuetify.theme.success"
                :labels="{ checked: 'ON', unchecked: 'OFF' }"
                style="display: inline-block"
                @change="onChangeToggleClosePlatFrom('ig')"
              />
            </div>
          </v-flex>
        </v-layout>
        <v-divider class="my-3" />
      </template>

      <div
        v-if="
          ['studio7', 'ustore', 'ticket2', 'toa'].includes(selectedBot.theme) && !loadingSetting
        "
      >
        <Ticket2AdminDefaultMessage></Ticket2AdminDefaultMessage>
      </div>
      <div v-if="['tdtawandang'].includes(selectedBot.theme) && !loadingSetting">
        <TDAdminDefaultMessage></TDAdminDefaultMessage>
      </div>

      <template v-if="selectedBot && selectedBot.type === 'gpf'">
        <gpf-setting-bot v-if="botStatus"></gpf-setting-bot>
      </template>
      <div v-else class="row">
        <manage-open-time-bot v-if="botStatus"></manage-open-time-bot>
      </div>
    </v-container>
    <v-divider></v-divider>
    <v-container>
      <ReplyCommentFlagConfig />
    </v-container>
    <v-divider></v-divider>
    <div class="container">
      <v-layout wrap>
        <v-flex xs8 class="col s8">
          <div style="margin-top: 10px">
            {{ $t('Disallowing a bot to reply repeated questions') }}
          </div>
        </v-flex>
        <v-flex xs4 class="col s4 text-xs-right">
          <label
            class="toggle-switch small"
            style="margin-top: 10px; margin-bottom: 10px; vertical-align: bottom"
          >
            <input type="checkbox" :checked="pauseStatus" @change="togglePauseStatus()" />
            <span class="toggle-slider lever round"></span>
          </label>
        </v-flex>
        <v-flex style="margin-top: 10px">
          <label for>{{
            $t('* Note: Affect only for Conversation Page (not include Reply to Comment Page)')
          }}</label>
        </v-flex>
      </v-layout>
    </div>
    <v-divider></v-divider>
    <div class="container">
      <v-layout wrap>
        <v-flex xs9 class="col s9">{{ $t('Typing Time') }}</v-flex>
        <v-flex xs3 class="col s3 text-xs-right">
          <v-btn v-if="!isEditDelay" icon outline color="primary" @click="isEditDelay = true">
            <v-icon>edit</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xs12 class="col s12">
          <v-layout wrap>
            <v-flex xs6>
              <h3>{{ $t('Facebook') }}</h3>
              <h3 class="headline">{{ delayMessage.facebook }}s</h3>
            </v-flex>
            <v-flex xs6>
              <h3>{{ $t('Line') }}</h3>
              <h3 class="headline">{{ delayMessage.line }}s</h3>
            </v-flex>
          </v-layout>

          <label for>{{
            $t(
              'User can set the typing time for Bot to reply, and it will apply to all conversation.'
            )
          }}</label>
        </v-flex>
        <v-flex v-if="isEditDelay" xs12 class="col s12">
          <div class="mt-3">
            <h3>{{ $t('Facebook') }}</h3>
            <v-slider
              v-model="delayMessage.facebook"
              :color="$vuetify.theme.primary"
              ticks
              always-dirty
              min="0"
              max="10"
              step="0.5"
              thumb-label
              @change="onChangeDelayMessage"
            >
              <template #prepend>
                <a href="javascript:void(0)" @click="decrementDelayMessage('facebook')">
                  <span class="fas fa-minus"></span>
                </a>
              </template>

              <template #append>
                <a href="javascript:void(0)" @click="incrementDelayMessage('facebook')">
                  <span class="fas fa-plus"></span>
                </a>
              </template>
            </v-slider>
          </div>
          <div>
            <h3>{{ $t('Line') }}</h3>
            <v-slider
              v-model="delayMessage.line"
              :color="$vuetify.theme.primary"
              ticks
              always-dirty
              min="0"
              max="10"
              step="0.5"
              thumb-label
              @change="onChangeDelayMessage"
            >
              <template #prepend>
                <a href="javascript:void(0)" @click="decrementDelayMessage('line')">
                  <span class="fas fa-minus"></span>
                </a>
              </template>

              <template #append>
                <a href="javascript:void(0)" @click="incrementDelayMessage('line')">
                  <span class="fas fa-plus"></span>
                </a>
              </template>
            </v-slider>
          </div>

          <div class="text-xs-center">
            <v-btn outline color="grey" @click="onCancelEditDelayMessage">{{ $t('cancel') }}</v-btn>
            <v-btn color="primary" @click="onSaveEditDelayMessage">{{ $t('Save') }}</v-btn>
          </div>
        </v-flex>
      </v-layout>
    </div>
    <template v-if="!loadingSetting && !['scgdistribution'].includes(selectedBot.theme)">
      <v-divider></v-divider>
      <AdminHandOver></AdminHandOver>
    </template>
    <template v-if="isAiraAifulPage">
      <v-divider></v-divider>
      <SettingDeleteUser></SettingDeleteUser>
    </template>
    <v-divider></v-divider>

    <div class="container">
      <v-layout wrap>
        <v-flex xs12>
          <h3 class="headline">
            {{ $t('Line Notify') }}
            <a
              href="https://blog.zwiz.ai/line-notify-%E0%B9%81%E0%B8%88%E0%B9%89%E0%B8%87%E0%B9%80%E0%B8%95%E0%B8%B7%E0%B8%AD%E0%B8%99%E0%B8%9C%E0%B9%88%E0%B8%B2%E0%B8%99%E0%B9%84%E0%B8%A5%E0%B8%99%E0%B9%8C/"
            >
              <em style="font-size: 20px" class="fas fa-question-circle" />
            </a>
          </h3>
        </v-flex>
      </v-layout>
      <div v-if="loadingLineNotify" class="text-xs-center"></div>
      <div
        v-else
        style="position: relative; padding: 10px 0px"
        :style="{ 'min-height': $store.getters.getPackage != 'premium' ? '174px' : '0px' }"
      >
        <v-premium-plan-popup
          v-if="$store.getters.getPackage != 'premium'"
          :show-all="false"
          style="border-radius: 10px"
        ></v-premium-plan-popup>
        <v-layout v-if="!isLinkedLineNotify" wrap>
          <v-flex xs5 md8 class="col s5 m8">{{ $t('Not connect to the account') }}</v-flex>
          <v-flex xs7 md4 class="col s7 m4 text-xs-right">
            <template v-if="$store.getters.getPackage == 'premium'">
              <v-btn outline color="primary" :href="lineNotifyLink">{{ $t('Link Account') }}</v-btn>
            </template>
            <template v-else>
              <v-btn outline color="primary">{{ $t('Link Account') }}</v-btn>
            </template>
          </v-flex>
        </v-layout>
        <div class="row">
          <div
            v-for="(person, index) in linenotifylist"
            :key="'line_' + index"
            class="col s12"
            style="margin-bottom: 10px"
          >
            <div class="z-border-red">
              <v-layout wrap style="margin-bottom: 0">
                <v-flex xs8 class="col s8" style="padding: 10px 20px">
                  <img
                    :src="'https://graph.facebook.com/' + person.adminid + '/picture?type=square'"
                    width="50"
                    height="50"
                    :alt="person.name"
                    style="border-radius: 50%; margin-right: 10px; float: left"
                    @error="onFailLoad"
                  />
                  <div style="margin-top: 13px">{{ person.name || '-' }}</div>
                </v-flex>
                <v-flex
                  v-if="person.adminid == $store.state.userid || getBotPageRole == true"
                  xs4
                  class="col s4 text-xs-right"
                  style="padding: 10px 20px"
                >
                  <v-btn icon outline color="primary" small @click="deleteLineNotify(person)">
                    <span class="fas fa-trash-alt"></span>
                  </v-btn>
                </v-flex>
              </v-layout>
            </div>
          </div>
        </div>

        <div v-if="linenotifylist && linenotifylist.length > 0" class="mt-4">
          <h3 class="headline">{{ $t('Notification Settings') }}</h3>
          <div class="mt-2" style="border-radius: 10px; border: 1px solid #eee">
            <v-layout wrap row align-center class="my-2">
              <v-flex xs8>
                <div class="px-3 py-3">{{ $t('All conversation') }}</div>
              </v-flex>
              <v-flex xs4 class="pr-3 text-xs-right">
                <label class="toggle-switch small" style="vertical-align: bottom">
                  <input
                    type="checkbox"
                    :checked="linenotify.notify_intent"
                    @change="onChangeLineNotify('notify_intent')"
                  />
                  <span class="toggle-slider lever round"></span>
                </label>
              </v-flex>
            </v-layout>

            <template v-if="linenotify.notify_intent">
              <v-divider />
              <v-layout wrap row align-center class="my-2">
                <v-flex xs8>
                  <div class="px-3 py-3">{{ $t('Selected conversation') }}</div>
                </v-flex>
                <v-flex xs4 class="pr-3 text-xs-right">
                  <div class="py-2">
                    <a href="#" @click="showEditLineNotifyConversation = true">{{ $t('edit') }}</a>
                  </div>
                </v-flex>
              </v-layout>
            </template>

            <v-divider />
            <v-layout wrap row align-center class="my-2">
              <v-flex xs8>
                <div class="px-3 py-3">{{ $t('All Comments') }}</div>
              </v-flex>
              <v-flex xs4 class="pr-3 text-xs-right">
                <label class="toggle-switch small" style="vertical-align: bottom">
                  <input
                    type="checkbox"
                    :checked="linenotify.notify_comment"
                    @change="onChangeLineNotify('notify_comment')"
                  />
                  <span class="toggle-slider lever round"></span>
                </label>
              </v-flex>
            </v-layout>

            <template v-if="linenotify.notify_comment">
              <v-divider />
              <v-layout wrap row align-center class="my-2">
                <v-flex xs8>
                  <div class="px-3 py-3">{{ $t('Selected comment') }}</div>
                </v-flex>
                <v-flex xs4 class="pr-3 text-xs-right">
                  <div class="py-2">
                    <a href="#" @click="showEditLineNotifyReplyComment = true">{{ $t('edit') }}</a>
                  </div>
                </v-flex>
              </v-layout>
            </template>

            <template v-if="$store.state.shoptheme.includes(selectedBot.theme)">
              <v-divider />
              <v-layout wrap row align-center class="my-2">
                <v-flex xs8>
                  <div class="px-3 py-3">{{ $t('Notify when customer ordered') }}</div>
                </v-flex>
                <v-flex xs4 class="pr-3 text-xs-right">
                  <label class="toggle-switch small" style="vertical-align: bottom">
                    <input
                      type="checkbox"
                      :checked="linenotify.notify_neworder"
                      @change="onChangeLineNotify('notify_neworder')"
                    />
                    <span class="toggle-slider lever round"></span>
                  </label>
                </v-flex>
              </v-layout>

              <v-divider />
              <v-layout wrap row align-center class="my-2">
                <v-flex xs8>
                  <div class="px-3 py-3">{{ $t('Notify when customer paid') }}</div>
                </v-flex>
                <v-flex xs4 class="pr-3 text-xs-right">
                  <label class="toggle-switch small" style="vertical-align: bottom">
                    <input
                      type="checkbox"
                      :checked="linenotify.notify_payment"
                      @change="onChangeLineNotify('notify_payment')"
                    />
                    <span class="toggle-slider lever round"></span>
                  </label>
                </v-flex>
              </v-layout>
              <v-divider />
              <v-layout wrap row align-center class="my-2">
                <v-flex xs8>
                  <div class="px-3 py-3">{{ $t('Notify when token expired') }}</div>
                </v-flex>
                <v-flex xs4 class="pr-3 text-xs-right">
                  <label class="toggle-switch small" style="vertical-align: bottom">
                    <input
                      type="checkbox"
                      :checked="linenotify.notify_token_expired"
                      @change="onChangeLineNotify('notify_token_expired')"
                    />
                    <span class="toggle-slider lever round"></span>
                  </label>
                </v-flex>
              </v-layout>
            </template>
          </div>
          <manage-single-line-notify
            v-if="showEditLineNotifyConversation"
            @close="showEditLineNotifyConversation = false"
          ></manage-single-line-notify>

          <manage-single-line-notify
            v-if="showEditLineNotifyReplyComment"
            type="replycomment"
            @close="showEditLineNotifyReplyComment = false"
          ></manage-single-line-notify>
        </div>
      </div>
    </div>

    <!-- <v-divider></v-divider>
      <div class="pb-4 text-xs-center">
        <v-container>
          <h4>{{$t('Support2')}}</h4>
          <support-code @updateSupportCode="onUpdateSupportCode"></support-code>
        </v-container>
      </div>-->

    <template v-if="selectedBot.pagetype !== 'enterprise'">
      <v-divider></v-divider>
      <v-divider></v-divider>
      <v-container>
        <h3 class="headline">{{ $t('Integrated Partner') }}</h3>
        <chatday></chatday>
      </v-container>
    </template>

    <template v-if="selectedBot && selectedBot.hasOwnProperty('synctagsfacebook_status')">
      <v-divider />
      <facebook-tags></facebook-tags>
    </template>

    <v-divider></v-divider>
    <div v-if="!['100707492390105'].includes(selectedBot.pageid)" class="container">
      <v-layout align-center>
        <v-flex xs5>{{ $t('remove bot') }}</v-flex>
        <v-flex xs7 class="text-xs-right">
          <v-btn color="error" @click="onUnsubscribeBot">{{ $t('remove bot') }}</v-btn>
        </v-flex>
      </v-layout>
    </div>
    <div class="my-5"></div>
  </div>
</template>

<script>
import api from '@/api'
import config from '@/config'
import moment from 'moment'
import { ToggleButton } from 'vue-js-toggle-button'
import { mapGetters } from 'vuex'
import AdminHandOver from './adminHandOver.vue'
import Chatday from './Chatday'
import FacebookTags from './FacebookTags'
import GpfSettingBot from './GpfSettingBot'

import ManageOpenTimeBot from './ManageOpenTimeBot'
import ManageSingleLineNotify from './ManageSingleLineNotify'
import SettingDeleteUser from './SettingDeleteUser.vue'

import TDAdminDefaultMessage from './TDAdminDefaultMessage'
import Ticket2AdminDefaultMessage from './Ticket2AdminDefaultMessage'
import { PAGE } from '@/constants/page.js'
import ReplyCommentFlagConfig from './ReplyCommentFlagConfig.vue'
import { handleApiError } from '@/api/util'

export default {
  name: 'BotSetting',
  components: {
    ToggleButton,
    ManageSingleLineNotify,
    ManageOpenTimeBot,
    AdminHandOver,
    SettingDeleteUser,
    Chatday,
    FacebookTags,
    Ticket2AdminDefaultMessage,
    TDAdminDefaultMessage,
    GpfSettingBot,
    ReplyCommentFlagConfig
  },
  data: function () {
    return {
      onOffbotToggle: false,
      toggleLine: false,
      toggleIg: false,
      toggleWhatsapp: false,
      toggleFacebook: false,
      expriedDate: null,
      expriedTime: null,
      isEdit: false,
      botStatus: false,
      pauseStatus: false,
      line: {
        line_access_token: null,
        line_channel_secret: null,
        line_channel_id: null
      },
      showCopy: false,
      delayMessageTime: 0,
      isEditDelay: false,
      loadingLineNotify: true,
      linenotifylist: [],
      showEditLineNotifyConversation: false,
      showEditLineNotifyReplyComment: false,
      linenotify: {
        notify_comment: false,
        notify_intent: false,
        notify_neworder: false,
        notify_payment: false,
        notify_token_expired: false
      },
      loadingFacebookPay: true,
      facebookPayStatus: false,
      delayMessage: {
        facebook: 0,
        line: 0
      }
    }
  },

  computed: {
    selectedBotStatus() {
      return this.selectedBot.status
    },
    ...mapGetters({
      botlist: 'botlist',
      allPage: 'allPage',
      currentLang: 'currentLang',
      selectedBot: 'selectedBot',
      loadingSetting: 'getLoadingSetting'
    }),
    getBotPageRole: function () {
      var vm = this
      var bot = vm.allPage.find(function (val) {
        return val.id == vm.selectedBot.pageid
      })
      if (bot) {
        if (bot.perms) {
          return bot.perms.indexOf('ADMINISTER') > -1
        } else if (bot.tasks) {
          return bot.tasks.indexOf('MANAGE') > -1
        } else {
          return null
        }
      } else {
        return null
      }
    },
    isLinkedLineNotify: function () {
      var vm = this
      if (!vm.selectedBot) {
        return false
      }
      return (
        vm.linenotifylist.findIndex(function (el) {
          return el.pageid == vm.selectedBot.pageid && el.adminid == vm.$store.state.userid
        }) > -1
      )
    },
    lineNotifyLink: function () {
      return (
        'https://notify-bot.line.me/oauth/authorize?response_type=code&client_id=vf6yxOil8ZhEDPxgKtZd6c&redirect_uri=' +
        window.location.protocol +
        '//' +
        window.location.hostname +
        (window.location.port ? ':' + window.location.port : '') +
        '/linenotify&scope=notify&state=zwizai'
      )
    },
    expiredat: function () {
      if (this.selectedBot) {
        return this.$store.state.selectedBot.expireat
      } else {
        return null
      }
    },
    selectedBot: {
      get() {
        if (this.$store.state.selectedBot == null) {
          return null
        }
        return this.$store.state.selectedBot
      },
      set(bot) {
        let vm = this
        vm.currentBot = bot
        vm.$store.dispatch('selectBot', vm.currentBot)
        location.reload()
      }
    },
    webhookUrl: function () {
      return config.webhookUrl + 'webhookline?facebookpageid=' + this.selectedBot.pageid
    },
    isAiraAifulPage() {
      return PAGE.AIRA_AIFUL.includes(this.selectedBot.pageid)
    }
  },
  watch: {
    selectedBotStatus() {
      let vm = this
      vm.botStatus = vm.selectedBot.status
    },
    expiredat(newVal, oldVal) {
      if (newVal != oldVal) {
        if (this.expiredat) {
          var now = moment()
          var expriedDate = moment(this.expiredat)
          this.expriedDate = parseInt(expriedDate.diff(now, 'days'))
          this.expriedTime = parseInt(expriedDate.diff(now, 'seconds'))
        }
      }
    }
  },
  mounted: async function () {
    var vm = this
    vm.toggleLine = vm.selectedBot.line_status
    vm.toggleIg = vm.selectedBot.instagram_status
    vm.toggleFacebook = vm.selectedBot.facebook_status
    vm.botStatus = vm.selectedBot.status
    vm.loadingLineNotify = true
    vm.$store.dispatch('loadSetting')
    try {
      await vm.$store.dispatch('updateBotDetail')
      vm.linenotify = {
        notify_comment: vm.selectedBot.notify_comment,
        notify_intent: vm.selectedBot.notify_intent,
        notify_neworder: vm.selectedBot.notify_neworder,
        notify_payment: vm.selectedBot.notify_payment,
        notify_token_expired: vm.selectedBot.notify_token_expired
      }
    } catch (error) {
      console.error(error)
    }

    await vm.getPauseStatus()
    vm.loadingLineNotify = false

    vm.getLineNotify()
    await vm.getLineToken()

    vm.cached_line = JSON.stringify(vm.line)
    if (!vm.line.line_access_token || !vm.line.line_channel_secret) {
      vm.isEditLine = true
    }
    if (vm.$route.query.go === 'line') {
      const lineComponent = document.getElementById('_line')
      lineComponent.scrollIntoView()
    }

    await vm.getDelayMessage()
    vm.cached_delay_message_time = vm.delayMessageTime
    vm.cached_delay_message_json = JSON.stringify(vm.delayMessage)

    this.loadingFacebookPay = true
    const facebookPayStatusResponse = await this.getFacebookPayStatus()
    if (facebookPayStatusResponse.status) {
      this.facebookPayStatus = facebookPayStatusResponse.status
    }
    this.loadingFacebookPay = false
  },
  methods: {
    async onChangeToggleClosePlatFrom(platfrom) {
      const vm = this
      let bodyData = vm.togglePlatform(platfrom)
      vm.$store.dispatch('loading')
      var data = {
        body: bodyData,
        pageid: vm.selectedBot.pageid
      }
      var res = await api.updatePageConfig(data)
      if (res.success) {
        //
      } else {
        vm.togglePlatform(platfrom)
      }
      vm.$store.dispatch('loading')
    },
    togglePlatform(platfrom) {
      let vm = this
      if (platfrom === 'facebook') {
        vm.toggleFacebook = !vm.toggleFacebook
        return { facebook_status: vm.toggleFacebook }
      } else if (platfrom === 'line') {
        vm.toggleLine = !vm.toggleLine
        return { line_status: vm.toggleLine }
      } else if (platfrom === 'ig') {
        vm.toggleIg = !vm.toggleIg
        return { instagram_status: vm.toggleIg }
      } else if (platfrom === 'whatsapp') {
        vm.toggleWhatsapp = !vm.toggleWhatsapp
        return { whatsapp_status: vm.toggleWhatsapp }
      } else {
        return {}
      }
    },
    getFacebookPayStatus() {
      var data = {
        pageid: this.selectedBot.pageid
      }
      return new Promise((resolve) => {
        api.getFacebookPayStatus(data, function (error, response) {
          if (error) {
            console.error(error)
            return
          }
          resolve(response)
        })
      })
    },
    onUpdateSupportCode: function () {
      location.reload()
    },
    onChangeLineNotify: function (type) {
      this.linenotify[type] = !this.linenotify[type]
      var data = this.linenotify
      data.pageid = this.selectedBot.pageid
      api.saveLineNotifyNotification(data, function (error) {
        if (error) {
          console.error(error)
          return
        }
      })
    },
    onFailLoad: function (event) {
      event.target.src = '/static/img/assets/livechat/profile.png'
    },
    deleteLineNotify: function (person) {
      var vm = this
      vm.$swal
        .fire({
          title: vm.$t('Do you want to unlink this?'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then((result) => {
          if (result.value) {
            vm.$store.dispatch('loading')
            api.deleteLineNotify(
              { pageid: person.pageid, adminid: person.adminid },
              function (error) {
                if (error) {
                  // reject(error)
                }
                var deleteIndex = vm.linenotifylist.findIndex(function (el) {
                  return el.pageid == person.pageid && el.adminid == person.adminid
                })
                if (deleteIndex > -1) {
                  vm.linenotifylist.splice(deleteIndex, 1)
                }
                vm.$store.dispatch('loading')
                // resolve()
              }
            )
          }
        })
    },
    getDelayMessage: async function () {
      const vm = this
      try {
        const response = await api.getReplyDelay({ pageid: vm.selectedBot.pageid })
        if (response.status == 200) {
          vm.delayMessageTime =
            response.data && response.data.data ? +response.data.data.replydelay / 1000 : 0

          const responseJson =
            response.data && response.data.data ? response.data.data.reply_delay_json : null

          if (responseJson) {
            vm.delayMessage = {
              facebook: responseJson.facebook / 1000,
              line: responseJson.line / 1000
            }
          }
        }
        return
      } catch (error) {
        handleApiError(error)
        return error
      }
    },
    onCancelEditDelayMessage: function () {
      var vm = this
      vm.delayMessageTime = vm.cached_delay_message_time
      vm.delayMessage = JSON.parse(vm.cached_delay_message_json)
      vm.isEditDelay = false
    },
    onSaveEditDelayMessage: async function () {
      const vm = this
      try {
        vm.$store.dispatch('loading')

        const delayMessageJson = {
          facebook: vm.delayMessage.facebook * 1000,
          line: vm.delayMessage.line * 1000
        }

        const response = await api.editReplyDelay({
          pageid: vm.selectedBot.pageid,
          replydelay: vm.delayMessageTime * 1000,
          reply_delay_json: JSON.stringify(delayMessageJson)
        })

        if (response && response.status === 200) {
          vm.cached_delay_message_time = vm.delayMessageTime
          vm.cached_delay_message_json = JSON.stringify(vm.delayMessage)
          vm.isEditDelay = false
        }
      } catch (error) {
        handleApiError(error)
      } finally {
        vm.$store.dispatch('clear_loading')
      }
    },
    decrementDelayMessage(channel) {
      this.delayMessage[channel] -= 0.5
    },
    incrementDelayMessage(channel) {
      this.delayMessage[channel] += 0.5
    },
    onChangeDelayMessage: function () {},
    getPauseStatus: function () {
      var vm = this
      return new Promise((resolve, reject) => {
        api.getPauseStatus({ pageid: vm.selectedBot.pageid }, function (error, response) {
          if (error) {
            reject(error)
          }
          vm.pauseStatus = response.data.notreplyduplicateintent === true
          resolve()
        })
      })
    },
    cancelEditLine: function () {
      var vm = this
      vm.line = JSON.parse(vm.cached_line)
      vm.isEditLine = false
    },
    saveEditLine: function () {
      var vm = this
      if (vm.$store.getters.getPackage !== 'premium') {
        vm.line = JSON.parse(vm.cached_line)
        vm.isEditLine = false
        return
      }
      vm.$store.dispatch('loading')
      api.saveLineToken(
        {
          pageid: vm.selectedBot.pageid,
          line_access_token: vm.line.line_access_token ? vm.line.line_access_token.trim() : '',
          line_channel_secret: vm.line.line_channel_secret
            ? vm.line.line_channel_secret.trim()
            : '',
          line_channel_id: vm.line.line_channel_id ? vm.line.line_channel_id.trim() : ''
        },
        function (error) {
          if (error) {
            vm.$store.dispatch('loading')
          }
          vm.cached_line = JSON.stringify(vm.line)
          vm.isEditLine = false
          vm.$store.dispatch('loading')
          location.reload()
        }
      )
    },
    getLineToken: function () {
      var vm = this
      return new Promise((resolve, reject) => {
        api.getLineToken({ pageid: vm.selectedBot.pageid }, function (error, response) {
          if (error) {
            reject(error)
            vm.$store.dispatch('loading')
          }
          vm.line = {
            line_access_token: response.data.line_access_token,
            line_channel_secret: response.data.line_channel_secret,
            line_channel_id: response.data.line_channel_id
          }
          resolve()
        })
      })
    },
    getLineNotify: function () {
      var vm = this
      return new Promise((resolve, reject) => {
        api.getLineNotify({ pageid: vm.selectedBot.pageid }, function (error, response) {
          if (error) {
            reject(error)
          }
          if (response.linenotifylist) {
            vm.linenotifylist = response.linenotifylist
          }
          resolve()
        })
      })
    },
    onUnsubscribeBot: function () {
      let vm = this
      vm.$swal
        .fire({
          title: vm.$t('Do you want to Unsubscribe this?'),
          text: vm.$t('Warning!! If you unsubscribe this, Bot data will be lost'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true,
          footer: vm.$t('If you want any help, please contact via E-mail: sales@zwiz.ai')
        })
        .then((result) => {
          if (result.value) {
            vm.$store.dispatch('loading')
            let bot = vm.selectedBot
            api.unSubscribe(bot, function (error) {
              if (error) {
                console.error(error)
                vm.$store.dispatch('loading')
                return
              }

              let newbotlist = vm.botlist
              if (newbotlist && newbotlist.length > 0) {
                newbotlist = newbotlist.index((item) => {
                  return item.pageid !== bot.pageid
                })
              }

              vm.$store.dispatch('unselectBot')
              vm.$store.dispatch('updateBotlist', newbotlist)
              vm.$store.dispatch('updatePagelist')
              vm.$store.dispatch('loading')
              vm.$router.push('/' + vm.currentLang + '/allbots')
            })
          }
        })
    },
    toggleBotStatus: function () {
      let vm = this
      let bot = Object.assign({}, vm.selectedBot)
      bot.status = !bot.status
      let data = {
        theme: bot.theme,
        page_access_token: bot.page_access_token,
        pageid: bot.pageid,
        status: bot.status
      }
      vm.$store.dispatch('loading')
      api.toggleBotStatus(data, function (error) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
          return
        }

        let newbotlist = vm.botlist
        if (newbotlist && newbotlist.length > 0) {
          newbotlist = newbotlist.map((item) => {
            if (item.pageid === bot.pageid) {
              item.status = bot.status
            }
            return item
          })
        }

        vm.botStatus = bot.status
        vm.$store.dispatch('selectBot', bot)
        vm.$store.dispatch('updateBotlist', newbotlist)
        vm.$store.dispatch('loading')
      })
    },
    togglePauseStatus: function () {
      let vm = this
      vm.pauseStatus = !vm.pauseStatus
      var data = {
        pageid: vm.selectedBot.pageid,
        notreplyduplicateintent: vm.pauseStatus
      }

      vm.$store.dispatch('loading')
      api.togglePauseStatus(data, function (error) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
          return
        }
        vm.selectedBot.notreplyduplicateintent = vm.pauseStatus
        vm.$store.dispatch('loading')
      })
    },
    onCopy: function () {
      let vm = this
      vm.showCopy = true
      setTimeout(() => {
        vm.showCopy = false
      }, 1000)
    },
    onError: function () {},
    onCopyError: function () {}
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/billing/Billing.vue